import { render, staticRenderFns } from "./PinPlugin.vue?vue&type=template&id=08875bc5&scoped=true"
import script from "./PinPlugin.vue?vue&type=script&lang=ts"
export * from "./PinPlugin.vue?vue&type=script&lang=ts"
import style0 from "./PinPlugin.vue?vue&type=style&index=0&id=08875bc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08875bc5",
  null
  
)

export default component.exports